import { render, staticRenderFns } from "./Myclient.vue?vue&type=template&id=51aa4b13&scoped=true"
import script from "./Myclient.vue?vue&type=script&lang=js"
export * from "./Myclient.vue?vue&type=script&lang=js"
import style0 from "./Myclient.vue?vue&type=style&index=0&id=51aa4b13&prod&scoped=true&lang=less"
import style1 from "./Myclient.vue?vue&type=style&index=1&id=51aa4b13&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aa4b13",
  null
  
)

export default component.exports